export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8242.a17e4e3a.jpg";